import {
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  Input,
  InputProps,
} from "@chakra-ui/react";
import { FieldProps } from "formik";
import React from "react";
import { IBaseInput } from "./types";
import get from "lodash.get";
import OptimisedField from "./optimisedField";

interface ITextInput extends InputProps, IBaseInput {
  name: string;
  helperText?: string;
}

const TextInput: React.FC<ITextInput> = ({
  name,
  label,
  optimise,
  isRequired,
  isDisabled,
  helperText,
  ...rest
}) => {
  return (
    <OptimisedField optimise={optimise} name={name}>
      {(fieldProps: FieldProps<string>) => {
        const { form, field } = fieldProps;
        const error = get(form.errors, name);
        const isInvalid = !!error && !!get(form.touched, name);

        return (
          <FormControl
            isInvalid={isInvalid}
            isRequired={isRequired}
            isDisabled={isDisabled || form.isSubmitting}
          >
            <FormLabel htmlFor={name}>{label}</FormLabel>
            <Input {...rest} {...field} />
            {error && <FormErrorMessage>{error}</FormErrorMessage>}
            {helperText && <FormHelperText>{helperText}</FormHelperText>}
          </FormControl>
        );
      }}
    </OptimisedField>
  );
};

export default TextInput;
